import cx from 'classnames';
import { atom, useAtom } from 'jotai';
import { Dispatch, FunctionComponent, SetStateAction, useRef } from 'react';

import TextInput from '../../../ui/v2/inputs/text';
import useIsMobile from '../../../../hooks/use-is-mobile';

type TSearchInput = {
  search?: string;
  setSearch?: Dispatch<SetStateAction<string | undefined>>;
  placeholder: string;
  isFullWith?: boolean;
  scrollToTop?: boolean;
  targetId?: string | undefined;
  onInputFocus?: any;
  onInputBlur?: any;
};

const searchInputAtom = atom('');

const SearchInput: FunctionComponent<TSearchInput> = ({
  search = '',
  setSearch,
  placeholder,
  isFullWith = false,
  targetId,
  onInputFocus,
  onInputBlur,
  scrollToTop = false,
}) => {
  const [, setsearchAtom] = useAtom(searchInputAtom);
  const isMobile = useIsMobile();

  return (
    <div
      className={cx(
        'flex w-full z-20 group',
        { 'lg:w-1/2': !isFullWith },
        'mx-auto'
      )}
    >
      <TextInput
        value={search}
        onChange={(e) => {
          if (setSearch) {
            setSearch(e.currentTarget.value);
          }
          setsearchAtom(e.currentTarget.value);
          document
            .getElementById(targetId || 'scroll_to_search')
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }}
        placeholder={placeholder}
        labelBehaviour="animated"
        variant="filter"
        border
        clearButton={true}
        showExtraIcon={true}
        onClear={() => {
          if (setSearch) {
            setSearch(undefined);
            setsearchAtom('');
          }
        }}
        onBlur={onInputBlur}
        onFocus={onInputFocus}
        backButtonOnFocus={isMobile ? true : false}
      />
    </div>
  );
};

export default SearchInput;
